module.exports = __webpack_public_path__ + "img/DatenbankFunktionenLayer.94bce849.png";